import { useMutation } from '@tanstack/react-query';
import api from '@api/http/api';

export function useUpgradeAllyMutation() {
  return useMutation<{ success: boolean }, {}, { id: string }>({
    mutationFn: (values) => api.post('/allies/upgrade', values),
  });
}

export function useActivateAllyMutation() {
  return useMutation<{ success: true }, {}, { id: string }>({
    mutationFn: (values) => api.post('/allies/activate', values),
  });
}